import { Injectable } from '@angular/core';
import { AssessmentAdministrator } from '../../core-data-model/AssessmentAdministrator.model';
import { InitData } from '../../core-data-model/InitData.model';
import { Util } from '../../core-utilities/Util';
import { InitDataServer } from './InitData.serverinterface';

@Injectable({ providedIn: 'root' })
export class InitDataTransformers {
    constructor(private util: Util) {}

    transformServerToClient(serverInitData: InitDataServer): InitData {
        const accountConfigServer = serverInitData.initData.accountConfig;
        const accountConfig = Object.assign({}, accountConfigServer, {
            companyCreateDate: this.util.newDate(
                accountConfigServer.companyCreateDate
            )
        });
        const initDataClient: InitData = {
            accountConfig,
            accessibleFeaturesList: serverInitData.accessibleFeaturesList,
            administrator: new AssessmentAdministrator(
                serverInitData.initData.administrator
            ),
            userProfile: {
                firstName: serverInitData.userProfile.firstName,
                lastName: serverInitData.userProfile.lastName,
                userGuid: serverInitData.userProfile.userGuid,
                email: serverInitData.userProfile.email,
                defaultFolderGuid: serverInitData.userProfile.defaultFolderGuid,
                defaultFolderPath: serverInitData.userProfile.defaultFolderPath,
                defaultLanguageCode:
                    serverInitData.userProfile.defaultLanguageCode,
                defaultTimeZoneIdentifier:
                    serverInitData.userProfile.defaultTimeZoneIdentifier,
                hasAcknowledgedCogBestPractices:
                    serverInitData.userProfile.hasAcknowledgedCogBestPractices,
                hasAcknowledgedWelcomeGuideCta:
                    serverInitData.userProfile.hasAcknowledgedWelcomeGuideCta,
                isUsingBetaSite: serverInitData.userProfile.isUsingBetaSite,
                settings: JSON.parse(serverInitData.userProfile.settings)
            }
        };
        return initDataClient;
    }
}
